import { InsurerView, Modal } from "components";
import { useNavigate, useSearch } from "react-location";
import { withPermissions, wrapClick } from "utils";

import { Action } from "components/buttons/action-button";
import { LocationGenerics } from "router/location";
import { useInsurer } from "hooks/data/use-insurers";

export default function ViewInsurerContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const navigate = useNavigate<LocationGenerics>();
  const { insurer, loading } = useInsurer(searchParams?.id || "");
  const dispatchAction =
    (id: string, action: Exclude<Action, "expand" | "goto" | "clone">) =>
    () => {
      navigate({
        search: (old) => ({
          ...old,
          id,
          modal: action,
        }),
      });
    };
  const expandItem = () => {
    navigate({
      to: `./${searchParams.id}/view`,
    });
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="Insurer Information"
      description="Details of insurer are shown below"
      renderActions={() => (
        <>
          {withPermissions([
            "*:*",
            "insurers:*",
            "insurers:update",
            "insurers:manage",
          ])(
            <button
              type="button"
              onClick={dispatchAction(insurer?.insurer_id || "", "update")}
              className="ml-3 inline-flex items-center rounded-md border border-transparent bg-primary-600 px-3 py-2 text-sm leading-4 text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            >
              Update Insurer Details
            </button>
          )}
          <button
            type="button"
            onClick={wrapClick(expandItem)}
            className="ml-3 inline-flex items-center rounded-md border border-transparent bg-primary-600 px-3 py-2 text-sm leading-4 text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
          >
            View More
          </button>
        </>
      )}
    >
      <InsurerView insurer={insurer} />
    </Modal>
  );
}
